import { computed } from "@ember/object";
import { trustHTML } from "@ember/template";
import { tagName } from "@ember-decorators/component";
import { i18n } from "discourse-i18n";
import AdComponent from "./ad-component";

@tagName("")
export default class AmazonProductLinks extends AdComponent {
  init() {
    const data = {
      "above-site-header": {},
      "topic-list-top": {},
      "topic-above-post-stream": {},
      "topic-above-suggested": {},
      "post-bottom": {},
    };
    const mobileView = this.site.get("mobileView");
    const placement = this.get("placement");

    if (!mobileView && this.siteSettings.amazon_above_site_header_src_code) {
      data["above-site-header"]["user_input"] =
        this.siteSettings.amazon_above_site_header_src_code;
      data["above-site-header"]["amazon_width"] = parseInt(
        this.siteSettings.amazon_above_site_header_ad_width_code,
        10
      );
      data["above-site-header"]["amazon_height"] = parseInt(
        this.siteSettings.amazon_above_site_header_ad_height_code,
        10
      );
    }

    if (
      mobileView &&
      this.siteSettings.amazon_mobile_above_site_header_src_code
    ) {
      data["above-site-header"]["user_input_mobile"] =
        this.siteSettings.amazon_mobile_above_site_header_src_code;
      data["above-site-header"]["mobile_amazon_width"] = parseInt(
        this.siteSettings.amazon_mobile_above_site_header_ad_width_code,
        10
      );
      data["above-site-header"]["mobile_amazon_height"] = parseInt(
        this.siteSettings.amazon_mobile_above_site_header_ad_height_code,
        10
      );
    }

    if (!mobileView && this.siteSettings.amazon_topic_list_top_src_code) {
      data["topic-list-top"]["user_input"] =
        this.siteSettings.amazon_topic_list_top_src_code;
      data["topic-list-top"]["amazon_width"] = parseInt(
        this.siteSettings.amazon_topic_list_top_ad_width_code,
        10
      );
      data["topic-list-top"]["amazon_height"] = parseInt(
        this.siteSettings.amazon_topic_list_top_ad_height_code,
        10
      );
    }

    if (mobileView && this.siteSettings.amazon_mobile_topic_list_top_src_code) {
      data["topic-list-top"]["user_input_mobile"] =
        this.siteSettings.amazon_mobile_topic_list_top_src_code;
      data["topic-list-top"]["mobile_amazon_width"] = parseInt(
        this.siteSettings.amazon_mobile_topic_list_top_ad_width_code,
        10
      );
      data["topic-list-top"]["mobile_amazon_height"] = parseInt(
        this.siteSettings.amazon_mobile_topic_list_top_ad_height_code,
        10
      );
    }

    if (
      !mobileView &&
      this.siteSettings.amazon_topic_above_post_stream_src_code
    ) {
      data["topic-above-post-stream"]["user_input"] =
        this.siteSettings.amazon_topic_above_post_stream_src_code;
      data["topic-above-post-stream"]["amazon_width"] = parseInt(
        this.siteSettings.amazon_topic_above_post_stream_ad_width_code,
        10
      );
      data["topic-above-post-stream"]["amazon_height"] = parseInt(
        this.siteSettings.amazon_topic_above_post_stream_ad_height_code,
        10
      );
    }

    if (
      mobileView &&
      this.siteSettings.amazon_mobile_topic_above_post_stream_src_code
    ) {
      data["topic-above-post-stream"]["user_input_mobile"] =
        this.siteSettings.amazon_mobile_topic_above_post_stream_src_code;
      data["topic-above-post-stream"]["mobile_amazon_width"] = parseInt(
        this.siteSettings.amazon_mobile_topic_above_post_stream_ad_width_code,
        10
      );
      data["topic-above-post-stream"]["mobile_amazon_height"] = parseInt(
        this.siteSettings.amazon_mobile_topic_above_post_stream_ad_height_code,
        10
      );
    }

    if (
      !mobileView &&
      this.siteSettings.amazon_topic_above_suggested_src_code
    ) {
      data["topic-above-suggested"]["user_input"] =
        this.siteSettings.amazon_topic_above_suggested_src_code;
      data["topic-above-suggested"]["amazon_width"] = parseInt(
        this.siteSettings.amazon_topic_above_suggested_ad_width_code,
        10
      );
      data["topic-above-suggested"]["amazon_height"] = parseInt(
        this.siteSettings.amazon_topic_above_suggested_ad_height_code,
        10
      );
    }

    if (
      mobileView &&
      this.siteSettings.amazon_mobile_topic_above_suggested_src_code
    ) {
      data["topic-above-suggested"]["user_input_mobile"] =
        this.siteSettings.amazon_mobile_topic_above_suggested_src_code;
      data["topic-above-suggested"]["mobile_amazon_width"] = parseInt(
        this.siteSettings.amazon_mobile_topic_above_suggested_ad_width_code,
        10
      );
      data["topic-above-suggested"]["mobile_amazon_height"] = parseInt(
        this.siteSettings.amazon_mobile_topic_above_suggested_ad_height_code,
        10
      );
    }

    if (!mobileView && this.siteSettings.amazon_post_bottom_src_code) {
      data["post-bottom"]["user_input"] =
        this.siteSettings.amazon_post_bottom_src_code;
      data["post-bottom"]["amazon_width"] = parseInt(
        this.siteSettings.amazon_post_bottom_ad_width_code,
        10
      );
      data["post-bottom"]["amazon_height"] = parseInt(
        this.siteSettings.amazon_post_bottom_ad_height_code,
        10
      );
    }

    if (mobileView && this.siteSettings.amazon_mobile_post_bottom_src_code) {
      data["post-bottom"]["user_input_mobile"] =
        this.siteSettings.amazon_mobile_post_bottom_src_code;
      data["post-bottom"]["mobile_amazon_width"] = parseInt(
        this.siteSettings.amazon_mobile_post_bottom_ad_width_code,
        10
      );
      data["post-bottom"]["mobile_amazon_height"] = parseInt(
        this.siteSettings.amazon_mobile_post_bottom_ad_height_code,
        10
      );
    }

    this.set("user_input", data[placement]["user_input"]);
    this.set("amazon_width", data[placement]["amazon_width"]);
    this.set("amazon_height", data[placement]["amazon_height"]);
    this.set("user_input_mobile", data[placement]["user_input_mobile"]);
    this.set("mobile_amazon_height", data[placement]["mobile_amazon_height"]);
    this.set("mobile_amazon_width", data[placement]["mobile_amazon_width"]);
    super.init();
  }

  @computed(
    "showAmazonAds",
    "showToGroups",
    "showAfterPost",
    "showOnCurrentPage"
  )
  get showAd() {
    return (
      this.showAmazonAds &&
      this.showToGroups &&
      this.showAfterPost &&
      this.showOnCurrentPage
    );
  }

  @computed("amazon_width", "amazon_height")
  get adWrapperStyle() {
    return trustHTML(
      `width: ${this.amazon_width}px; height: ${this.amazon_height}px;`
    );
  }

  @computed("mobile_amazon_width", "mobile_amazon_height")
  get adWrapperStyleMobile() {
    return trustHTML(
      `width: ${this.mobile_amazon_width}px; height: ${this.mobile_amazon_height}px;`
    );
  }

  @computed("mobile_amazon_width")
  get adTitleStyleMobile() {
    return trustHTML(`width: ${this.mobile_amazon_width}px;`);
  }

  @computed("user_input")
  get userInput() {
    return trustHTML(`${this.user_input}`);
  }

  @computed("user_input_mobile")
  get userInputMobile() {
    return trustHTML(`${this.user_input_mobile}`);
  }

  @computed
  get showAmazonAds() {
    if (!this.currentUser) {
      return true;
    }

    return this.currentUser.show_amazon_ads;
  }

  @computed("postNumber")
  get showAfterPost() {
    if (!this.postNumber) {
      return true;
    }

    return this.isNthPost(parseInt(this.siteSettings.amazon_nth_post_code, 10));
  }

  buildImpressionPayload() {
    return {
      ad_plugin_impression: {
        ad_type: this.site.ad_types.amazon,
        ad_plugin_house_ad_id: null,
        placement: this.placement,
      },
    };
  }

  <template>
    <div class="amazon-product-links" ...attributes>
      {{#if this.showAd}}
        {{#if this.site.mobileView}}
          <div
            class="amazon-product-links-label"
            style={{this.adTitleStyleMobile}}
          ><h2>{{i18n "adplugin.advertisement_label"}}</h2></div>
          <iframe
            frameborder="0"
            marginheight="0"
            marginwidth="0"
            scrolling="no"
            src={{this.userInputMobile}}
            style={{this.adWrapperStyleMobile}}
            title={{i18n "adplugin.advertisement_label"}}
          >
          </iframe>
        {{else}}
          <div class="amazon-product-links-label"><h2>{{i18n
                "adplugin.advertisement_label"
              }}</h2></div>
          <div align="center" class="container">
            <iframe
              frameborder="0"
              marginheight="0"
              marginwidth="0"
              scrolling="no"
              src={{this.userInput}}
              style={{this.adWrapperStyle}}
              title={{i18n "adplugin.advertisement_label"}}
            >
            </iframe>
          </div>
        {{/if}}
      {{/if}}
    </div>
  </template>
}
